import React, { Component } from 'react'
import Skeleton from '@mui/material/Skeleton'

/**
 * Informacion básica del alumno
 */
export default class SkeletonAlumno extends Component {

  //-------------------------------------------------------
  //-------------------- CLASS FUNCTIONS ------------------
  //-------------------------------------------------------


  //-------------------------------------------------------
  //------------------- RENDER FUNCTIONS ------------------
  //-------------------------------------------------------

  /**
   * Render
   *
   * @returns {Component}
   */
  render() {
    return (
        <>
            <div className="row">
                <div className='col-md-2'>
                    <Skeleton variant="rounded" width={"80%"} height={"100%"}/>
                </div>
                <div className='col-md-8'>
                    <Skeleton variant="text" sx={{ fontSize: '2.5em' }} width={"20%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '2em' }}   width={"30%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }}   width={"30%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }}   width={"30%"}/>
                </div>
                <div className='col-md-2 d-flex justify-content-end'>
                    <Skeleton variant="rounded" width={"50%"} height={40}/>
                </div>
            </div>

            <div className="row my-5">
                <div className='col-md-12'>
                    <Skeleton variant="text" sx={{ fontSize: '2em' }} width={"20%"}/>
                </div>
            </div>

            <div className="row my-5">
                <div className='col-md-3'>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                </div>

                <div className='col-md-3'>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                </div>

                <div className='col-md-3'>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                </div>

                <div className='col-md-3'>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                </div>
            </div>
        </>
    )
  }
}
